/*
 * POYTER — Hero carousel
 * Slow cross-dissolve, arrows, ticks, swipe, keyboard. Autoplay pauses on
 * hover, on focus and when the tab is hidden; respects prefers-reduced-motion.
 * Scoped per [data-section-type="pyt-hero"] so multiple instances and the
 * Theme Editor's section:load event are both handled.
 */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (!root || root.dataset.pytHeroInit) return;
    root.dataset.pytHeroInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.pyt-hero__slide'));
    if (slides.length < 2) return;

    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-hero-go]'));
    var count = root.querySelector('[data-hero-count]');
    var prev  = root.querySelector('[data-hero-prev]');
    var next  = root.querySelector('[data-hero-next]');

    var index = 0, timer = null;
    var autoplay = root.dataset.autoplay !== 'false';
    var seconds = parseInt(root.dataset.autoplaySeconds, 10);
    var DURATION = (isNaN(seconds) ? 7 : seconds) * 1000;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function go(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      ticks.forEach(function (t, i) {
        if (i === index) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      if (count) count.textContent = pad(index + 1) + ' / ' + pad(slides.length);
    }
    function play() {
      if (!autoplay || reduced.matches) return;
      stop();
      timer = window.setInterval(function () { go(index + 1); }, DURATION);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function step(dir) { go(index + dir); play(); }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    ticks.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.heroGo, 10)); play(); });
    });

    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) play(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    /* Touch: horizontal swipe only, so vertical scrolling is never hijacked. */
    var startX = null, startY = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      else play();
      startX = startY = null;
    }, { passive: true });

    go(0);
    play();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-section-type="pyt-hero"]');
    Array.prototype.forEach.call(roots, initHero);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* Theme Editor: re-initialise when a section is (re)loaded. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-section-type="pyt-hero"]') : null;
    if (root) { root.removeAttribute('data-pyt-hero-init'); initHero(root); }
  });
})();
